<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Rozetler</h1>
      </div>
      <div class="col-sm-6">
        <div class="float-right">
          <button class="btn btn-primary" (click)="openCreateModal()">
            <i class="fas fa-plus"></i> Yeni Rozet
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">

        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Yükleniyor...</span>
          </div>
        </div>

        <div *ngIf="!loading && badges.length === 0" class="alert alert-info">
          Henüz rozet bulunmamaktadır.
        </div>

        <div *ngIf="!loading && badges.length > 0" class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th style="width: 70px">Görsel</th>
                <th>Ad</th>
                <th>Açıklama</th>
                <th style="width: 80px">Sıra</th>
                <th style="width: 90px">Durum</th>
                <th style="width: 120px">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let badge of badges">
                <td class="text-center">
                  <img *ngIf="badge.image" [src]="badge.image"
                       style="width: 48px; height: 48px; object-fit: contain;"
                       [alt]="badge.name">
                  <span *ngIf="!badge.image" class="text-muted">-</span>
                </td>
                <td><strong>{{ badge.name }}</strong></td>
                <td>{{ badge.description }}</td>
                <td class="text-center">{{ badge.order }}</td>
                <td class="text-center">
                  <span [class]="badge.active ? 'badge badge-success' : 'badge badge-secondary'">
                    {{ badge.active ? 'Aktif' : 'Pasif' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-info mr-1" (click)="openEditModal(badge)" title="Düzenle">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" (click)="delete(badge)" title="Sil">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</section>
